/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Confirm_Delete_CriteriaInputs */

const en_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this search criteria? This will also remove all scraped jobs for it.`)
};

const de_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Suchkriterium löschen? Dadurch werden auch alle gescrapten Stellen dafür entfernt.`)
};

const fr_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer ce critère de recherche ? Cela supprimera également tous les emplois récupérés associés.`)
};

const es_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este criterio de búsqueda? También se eliminarán todos los empleos recopilados asociados.`)
};

const it_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questo criterio di ricerca? Questo rimuoverà anche tutti i lavori trovati.`)
};

const nl_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit zoekcriterium verwijderen? Dit verwijdert ook alle gevonden banen.`)
};

const pl_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć to kryterium wyszukiwania? Usunie to również wszystkie znalezione oferty.`)
};

const fi_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistetaanko tämä hakukriteeri? Tämä poistaa myös kaikki siihen liittyvät haetut työpaikat.`)
};

const da_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet dette søgekriterium? Dette fjerner også alle skrabede job for det.`)
};

const sv_jobs_confirm_delete_criteria = /** @type {(inputs: Jobs_Confirm_Delete_CriteriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera detta sökkriterium? Detta tar även bort alla skrapade jobb för det.`)
};

/**
* | output |
* | --- |
* | "Delete this search criteria? This will also remove all scraped jobs for it." |
*
* @param {Jobs_Confirm_Delete_CriteriaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_confirm_delete_criteria = /** @type {((inputs?: Jobs_Confirm_Delete_CriteriaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Confirm_Delete_CriteriaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_confirm_delete_criteria(inputs)
	if (locale === "fr") return fr_jobs_confirm_delete_criteria(inputs)
	if (locale === "es") return es_jobs_confirm_delete_criteria(inputs)
	if (locale === "it") return it_jobs_confirm_delete_criteria(inputs)
	if (locale === "nl") return nl_jobs_confirm_delete_criteria(inputs)
	if (locale === "pl") return pl_jobs_confirm_delete_criteria(inputs)
	if (locale === "fi") return fi_jobs_confirm_delete_criteria(inputs)
	if (locale === "da") return da_jobs_confirm_delete_criteria(inputs)
	if (locale === "sv") return sv_jobs_confirm_delete_criteria(inputs)
	return en_jobs_confirm_delete_criteria(inputs)
});